import { motion } from 'framer-motion';
import { Star, Heart, Shield, Sparkles } from 'lucide-react';
import './WhyJayraj.css'; // external CSS

// Sample data – replace with your own config
const whyChoose = [
  {
    title: 'Personalized Planning',
    description:
      'Every detail is curated to reflect your unique story, from the first consultation to the final farewell.',
    icon: Star,
  },
  {
    title: 'Unmatched Expertise',
    description:
      'With years of experience, we anticipate every need and handle the unexpected with grace.',
    icon: Heart,
  },
  {
    title: 'Premium Venues',
    description:
      'We partner with the most exclusive venues to ensure a breathtaking backdrop for your celebration.',
    icon: Shield,
  },
  {
    title: 'White‑Glove Service',
    description:
      'Our dedicated team offers concierge‑level support, making you and your guests feel truly cherished.',
    icon: Sparkles,
  },
];

export default function WhyJayraj() {
  return (
    <section className="why-jayraj-section">
      {/* Glowing background accent */}
      <div className="why-jayraj-glow" />

      <div className="why-jayraj-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="why-jayraj-header"
        >
          <p className="why-jayraj-subtitle">Why Choose Us</p>
          <h2 className="playfair-display why-jayraj-title">
            Luxury, Precision, and Heartfelt Service
          </h2>
          <p className="why-jayraj-description">
            We create destination weddings that feel effortless, refined, and truly personal from the very first conversation.
          </p>
        </motion.div>

        {/* Feature Cards Grid */}
        <div className="why-jayraj-grid">
          {whyChoose.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -6 }}
                className="why-jayraj-card group"
              >
                {/* Glowing corner indicator */}
                <div className="why-jayraj-card-corner" />

                {/* Icon */}
                <div className="why-jayraj-card-icon-wrapper">
                  <Icon className="why-jayraj-card-icon" />
                </div>

                {/* Title */}
                <h3 className="playfair-display why-jayraj-card-title">{item.title}</h3>

                {/* Description */}
                <p className="why-jayraj-card-description">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}